import React, {useEffect, useRef, useState} from 'react';
import RegisterLoginContent from './RegisterLoginContent';
import LinkedBankContent, {
	linkedBankByAccountSteps,
	linkedBankByCardSteps,
	linkedBankDirectBidvSteps,
	linkedBankDirectShbSteps
} from './LinkedBankContent';
import TopUpContent, {
	topUpAccountInfoQrSteps,
	topUpFromLinkedBankSteps,
	topUpFromTransferBankAppSteps,
	topUpFromTransferQrSteps
} from './TopUpContent';
import PhoneSwiper from '../Common/PhoneSwiper';
import './style.css';
import EkycContent from "./EkycContent";
import {PATH} from "../../constants";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {AnimatePresence, motion} from "framer-motion";

const GuildTabs = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const {menu: menuParam, subMenu: subMenuParam, childMenu: childMenuParam} = useParams();
	const [activeMenu, setActiveMenu] = useState(0);
	const [activeSubmenu, setActiveSubmenu] = useState(0);
	const [activeChildmenu, setActiveChildmenu] = useState(0);
	const [step, setStep] = useState(0);
	const [expandedMenu, setExpandedMenu] = useState(0);
	const guildRef = useRef(null);
	useEffect(() => {
		const hash = window.location.hash; // e.g., "#hdsd"
		if (hash === '#hdsd') {
			const element = guildRef.current;
			if (element) {
				const topPosition = element.getBoundingClientRect().top + window.pageYOffset;
				window.scrollTo({
					top: topPosition + 500,
				});
			}
		}
	}, []);
	
	const menus = [
		{
			label: 'Đăng ký/ Đăng nhập',
			slug: 'dang-ky-dang-nhap',
			items: [
				{
					label: 'Hướng dẫn đăng ký/đăng nhập',
					slug: 'huong-dan',
					quantity: 5,
					content: <RegisterLoginContent setStep={setStep} step={step}/>,
				},
			],
		},
		{
			label: 'Định danh điện tử',
			slug: 'dinh-danh-dien-tu',
			items: [
				{
					label: 'Hướng dẫn định danh điện tử',
					slug: 'huong-dan',
					quantity: 5,
					content: <EkycContent setStep={setStep} step={step}/>,
				},
			],
		},
		{
			label: 'Liên kết ngân hàng',
			slug: 'lien-ket-ngan-hang',
			items: [
				{
					label: 'Hướng dẫn liên kết ngân hàng trực tiếp',
					slug: 'truc-tiep',
					children: [
						{
							label: 'Ngân hàng SHB',
							slug: 'shb',
							quantity: linkedBankDirectShbSteps.length,
							content: <LinkedBankContent data={linkedBankDirectShbSteps} setStep={setStep} isLinkedBank step={step}/>,
						},
						{
							label: 'Ngân hàng BIDV',
							slug: 'bidv',
							quantity: linkedBankDirectBidvSteps.length,
							content: <LinkedBankContent data={linkedBankDirectBidvSteps} setStep={setStep} isLinkedBank step={step}/>,
						},
					],
				},
				{
					label: 'Hướng dẫn liên kết ngân hàng bằng số thẻ',
					slug: 'bang-so-the',
					quantity: linkedBankByCardSteps.length,
					content: <LinkedBankContent data={linkedBankByCardSteps} setStep={setStep} isLinkedBank step={step}/>,
				},
				{
					label: 'Hướng dẫn liên kêt ngân hàng bằng số tài khoản',
					slug: 'bang-so-tai-khoan',
					quantity: linkedBankByAccountSteps.length,
					content: <LinkedBankContent data={linkedBankByAccountSteps} setStep={setStep} isLinkedBank step={step}/>,
				},
			],
		},
		{
			label: 'Nạp tiền vào Ví',
			slug: 'nap-tien-vao-vi',
			items: [
				{
					label: 'Hướng dẫn lấy thông tin tài khoản và mã QR chuyển khoản',
					slug: 'lay-thong-tin-tai-khoan-va-ma-qr',
					quantity: topUpAccountInfoQrSteps.length,
					content: <TopUpContent data={topUpAccountInfoQrSteps} setStep={setStep} isSHB step={step}/>,
				},
				{
					label: 'Nạp tiền từ ngân hàng liên kết',
					slug: 'tu-ngan-hang-lien-ket',
					quantity: topUpFromLinkedBankSteps.length,
					content: <TopUpContent data={topUpFromLinkedBankSteps} setStep={setStep} isSHB step={step}/>,
				},
				{
					label: 'Nạp tiền từ Chuyển khoản vào ví bằng mã QR',
					slug: 'chuyen-khoan-qr',
					quantity: topUpFromTransferQrSteps.length,
					content: <TopUpContent data={topUpFromTransferQrSteps} setStep={setStep} isSHB step={step}/>,
				},
				{
					label: 'Nạp tiền từ Chuyển khoản vào ví bằng ứng dụng ngân hàng',
					slug: 'chuyen-khoan-app-ngan-hang',
					quantity: topUpFromTransferBankAppSteps.length,
					content: <TopUpContent data={topUpFromTransferBankAppSteps} setStep={setStep} isSHB step={step}/>,
				},
			],
		},
	];

	const buildGuildPath = ({menuIndex, subIndex, childIndex}) => {
		const menuSlug = menus[menuIndex]?.slug;
		const subSlug = menus[menuIndex]?.items?.[subIndex]?.slug;
		const childSlug = menus[menuIndex]?.items?.[subIndex]?.children?.[childIndex]?.slug;
		const parts = [PATH.GUILD];
		if (menuSlug) parts.push(menuSlug);
		if (subSlug) parts.push(subSlug);
		if (childSlug) parts.push(childSlug);
		return parts.join('/');
	};

	const isOnGuildRoute = () => {
		const p = location.pathname;
		return p === PATH.GUILD || p.startsWith(`${PATH.GUILD}/`);
	};

	const navigateGuildPath = (pathname) => {
		if (!isOnGuildRoute()) return;
		navigate({pathname, search: location.search});
	};

	useEffect(() => {
		// If no params, keep current state (default UI behavior).
		if (!menuParam) return;

		const menuIndex = menus.findIndex((m) => m.slug === menuParam);
		if (menuIndex < 0) return;

		const items = menus[menuIndex]?.items || [];
		const subIndex = subMenuParam ? items.findIndex((s) => s.slug === subMenuParam) : 0;
		const safeSubIndex = subIndex >= 0 ? subIndex : 0;

		const children = items[safeSubIndex]?.children || [];
		const childIndex = childMenuParam
			? children.findIndex((c) => c.slug === childMenuParam)
			: 0;
		const safeChildIndex = childIndex >= 0 ? childIndex : 0;

		setActiveMenu(menuIndex);
		setExpandedMenu(menuIndex);
		setActiveSubmenu(safeSubIndex);
		setActiveChildmenu(safeChildIndex);
		setStep(0);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [menuParam, subMenuParam, childMenuParam]);
	
	const onClickMenu = (index) => {
		setExpandedMenu((prev) => (prev === index ? -1 : index));
		setActiveMenu(index);
		setActiveSubmenu(0);
		setActiveChildmenu(0);
		setStep(0);
		const pathname = buildGuildPath({menuIndex: index, subIndex: 0, childIndex: 0});
		navigateGuildPath(pathname);
	}

	const onClickSubmenu = (menuIndex, submenuIndex) => {
		setExpandedMenu(menuIndex);
		setActiveMenu(menuIndex);
		setActiveSubmenu(submenuIndex);
		setActiveChildmenu(0);
		setStep(0);
		const pathname = buildGuildPath({menuIndex, subIndex: submenuIndex, childIndex: 0});
		navigateGuildPath(pathname);
	}

	const onClickChildmenu = (menuIndex, submenuIndex, childIndex) => {
		setExpandedMenu(menuIndex);
		setActiveMenu(menuIndex);
		setActiveSubmenu(submenuIndex);
		setActiveChildmenu(childIndex);
		setStep(0);
		const pathname = buildGuildPath({menuIndex, subIndex: submenuIndex, childIndex});
		navigateGuildPath(pathname);
	}
	
	const activeSub = menus[activeMenu]?.items?.[activeSubmenu];
	const activeItem = activeSub?.children ? activeSub.children[activeChildmenu] : activeSub;
	const enableSubmenuImages = activeMenu === 2 || activeMenu === 3;
	
	return (
		<>
			<div
				className="mx-auto my-8 md:w-[1100px] relative md:p-8 gap-20 md:rounded-[32px] md:border md:border-solid md:border-[#D6EBFF] md:shadow-[0_5px_5px_0_rgba(0,115,221,0.10)] bg-[white]"
				ref={guildRef}
			>
				<div className="mx-5 md:mx-0 md:w-[990px] max-w-6xl">
					<h2 className="text-2xl font-bold mb-6 uppercase">Hướng dẫn sử dụng</h2>
					<div className="flex flex-col gap-6 md:grid md:grid-cols-[4fr_3fr_6fr] md:gap-10 md:items-start min-w-0">
						<div className="bg-white/70 rounded-2xl py-4 md:min-w-[340px]">
							{menus.map((menu, index) => {
								const isExpanded = expandedMenu === index;
								const isActiveMenu = activeMenu === index;
								return (
									<div key={menu.label} className="border-b border-gray-200 last:border-b-0 py-1">
										<button
											type="button"
											onClick={() => onClickMenu(index)}
											className={`w-full flex items-center justify-between py-3 rounded-lg text-left text-sm transition-colors ${
												isActiveMenu ? 'text-[#0B2A4A] font-semibold' : 'text-gray-500'
											}`}
											aria-expanded={isExpanded}
										>
											<span>{menu.label}</span>
											<span className={`transition-transform ${isExpanded ? 'rotate-180' : ''}`}>
												<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
													<path d="M5 8L10 13L15 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
												</svg>
											</span>
										</button>
										<AnimatePresence initial={false}>
											{isExpanded && (
												<motion.div
													key={`${menu.label}-items`}
													initial={{height: 0, opacity: 0}}
													animate={{height: 'auto', opacity: 1}}
													exit={{height: 0, opacity: 0}}
													transition={{duration: 0.35, ease: [0.22, 1, 0.36, 1]}}
													className="pl-2 overflow-hidden"
												>
													{menu.items.map((item, itemIndex) => {
														const isActiveItem = isActiveMenu && activeSubmenu === itemIndex;
														const isChildContainer = !!item.children?.length;
														return (
															<div key={`${menu.label}-${item.label}`}>
																<button
																	type="button"
																	onClick={() => onClickSubmenu(index, itemIndex)}
																	className={`w-full text-left text-sm py-2 px-3 rounded-lg transition-colors flex items-center justify-between ${
																		isActiveItem ? 'bg-[#EAF4FF] text-[#0B2A4A] font-medium' : 'text-gray-700 hover:bg-gray-50'
																	}`}
																>
																	<span>{item.label}</span>
																	{isChildContainer && (
																		<span className={`transition-transform ${isActiveItem ? 'rotate-180' : ''}`}>
																			<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
																				<path d="M5 8L10 13L15 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
																			</svg>
																		</span>
																	)}
																</button>
																<AnimatePresence initial={false}>
																	{isChildContainer && isActiveItem && (
																		<motion.div
																			key={`${menu.label}-${item.label}-children`}
																			initial={{height: 0, opacity: 0}}
																			animate={{height: 'auto', opacity: 1}}
																			exit={{height: 0, opacity: 0}}
																			transition={{duration: 0.3, ease: [0.22, 1, 0.36, 1]}}
																			className="pl-3 mt-1 overflow-hidden"
																		>
																			{(item.children || []).map((child, childIndex) => {
																				const isActiveChild = isActiveItem && activeChildmenu === childIndex;
																				return (
																					<button
																						key={`${menu.label}-${item.label}-${child.label}`}
																						type="button"
																						onClick={() => onClickChildmenu(index, itemIndex, childIndex)}
																						className={`w-full text-left text-sm py-2 px-3 rounded-lg transition-colors ${
																							isActiveChild ? 'bg-[#DDEEFF] text-[#0B2A4A] font-medium' : 'text-gray-600 hover:bg-gray-50'
																						}`}
																					>
																						{child.label}
																					</button>
																				);
																			})}
																		</motion.div>
																	)}
																</AnimatePresence>
															</div>
														);
													})}
												</motion.div>
											)}
										</AnimatePresence>
									</div>
								);
							})}
						</div>
						
						<div className="w-full flex justify-center">
							<div className="w-full max-w-[360px] md:max-w-none">
								<PhoneSwiper
									quantity={activeItem?.quantity}
									activeTab={activeMenu}
									step={step}
									setStep={setStep}
									submenuIndex={enableSubmenuImages ? activeSubmenu : undefined}
									childIndex={enableSubmenuImages && activeSub?.children ? activeChildmenu : undefined}
								/>
							</div>
						</div>
						
						<div
							className="bg-transparent pt-0 md:pt-2 rounded-b-lg md:min-h-[560px] min-w-0 md:min-w-[400px] overflow-x-hidden"
							role="tabpanel"
							id={`tabpanel-${activeMenu}-${activeSubmenu}`}
							aria-labelledby={`menu-${activeMenu}`}
						>
							{activeItem?.content}
						</div>
					</div>
				</div>
			</div>
			<img className="z-[-1] mt-[-100px] md:mt-[-200px] w-full" src="/img/bg-city.png" alt="bg-city"/>
		</>
	);
};

export default GuildTabs;
